var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGovernance = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2783_293)",
    fill: "#9999AC"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.507 3.687h-1.1v-1h13.186v1H13.5v5.466A5.494 5.494 0 0 1 8 14.646a5.494 5.494 0 0 1-5.493-5.493V3.687Zm1 0v5.466A4.494 4.494 0 0 0 8 13.646v.5-.5a4.492 4.492 0 0 0 4.5-4.493V3.687H3.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39 6.864c.057 0 .106.023.146.068l.45.552.594-.724-.304-.372C7.046 6.129 6.773 6 6.456 6H5.203c-.01 0-.019.003-.025.01a.03.03 0 0 0-.01.022v.8a.03.03 0 0 0 .01.022c.006.007.015.01.025.01H6.39ZM9.551 6c-.319 0-.593.128-.823.384L7.394 8.016l-.858 1.048a.195.195 0 0 1-.147.068H5.202c-.01 0-.018.003-.024.01a.034.034 0 0 0-.007.022v.8c0 .01.002.02.007.026.006.007.014.01.024.01h1.25c.32 0 .594-.13.824-.388l.728-.888.728.888c.227.259.5.388.82.388h1.25c.01 0 .018-.003.023-.01a.035.035 0 0 0 .008-.022v-.8c0-.01-.002-.02-.008-.026-.005-.007-.013-.01-.023-.01H9.615a.187.187 0 0 1-.143-.064l-.878-1.072.874-1.064a.187.187 0 0 1 .147-.068h1.187c.01 0 .018-.003.023-.01a.035.035 0 0 0 .008-.022v-.8c0-.01-.002-.019-.008-.024-.005-.005-.013-.008-.023-.008h-1.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2783_293"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgGovernance;